import { PropsWithChildren, useRef } from 'react'

import { useCreation } from 'ahooks'

import { ImageCardContext } from './contexts/StoreContext'
import { ImageCardStoreProviderProps } from './interface'
import { createImageCardStore } from './store/createStore'
import { ImageCardStoreUpdater } from './StoreUpdater'

export const ImageCardStoreProvider = ({
  children,
  /* -------------------------------------------------------------------------- */
  /*                         ImageCardStoreUpdater Props                        */
  /* -------------------------------------------------------------------------- */
  ...restProps
}: PropsWithChildren<ImageCardStoreProviderProps>) => {
  const toolbarRef = useRef<HTMLDivElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  const store = useCreation(
    () => createImageCardStore({ toolbarRef, containerRef }),
    []
  )

  return (
    <ImageCardContext value={store}>
      <ImageCardStoreUpdater {...restProps} />
      {children}
    </ImageCardContext>
  )
}
